import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useOrg } from "../auth/OrgProvider";
import { ConfigBanner } from "../ui/ConfigBanner";
import { Button } from "../ui/Button";
import { cn } from "../lib/cn";

const navItems = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/leads", label: "Leads" },
  { to: "/customers", label: "Customers" },
  { to: "/properties", label: "Properties" },
  { to: "/services", label: "Services" },
];

export function DashboardLayout() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { memberships, activeOrg, activeOrgId, setActiveOrgId } = useOrg();

  async function handleSignOut() {
    await signOut();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <ConfigBanner />
      <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3">
        <div className="flex items-center gap-4">
          <Link to="/" className="text-brand-700 text-xl font-bold">
            LawnOps
          </Link>
          {memberships.length > 0 ? (
            <select
              className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm"
              value={activeOrgId ?? ""}
              onChange={(e) => setActiveOrgId(e.target.value)}
            >
              {memberships.map((m) => (
                <option key={m.organization_id} value={m.organization_id}>
                  {m.organization.name}
                </option>
              ))}
            </select>
          ) : null}
        </div>
        <div className="flex items-center gap-3 text-sm text-slate-600">
          <span>{user?.email}</span>
          <Button variant="ghost" onClick={handleSignOut}>
            Sign out
          </Button>
        </div>
      </header>
      <div className="flex flex-1">
        <nav className="w-56 shrink-0 border-r border-slate-200 bg-white px-3 py-4">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    cn(
                      "block rounded-md px-3 py-2 text-sm font-medium",
                      isActive ? "bg-brand-50 text-brand-700" : "text-slate-700 hover:bg-slate-100",
                    )
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          {activeOrg ? (
            <div className="mt-6 border-t border-slate-100 pt-4">
              <p className="px-3 text-xs uppercase tracking-wide text-slate-400">Active org</p>
              <p className="px-3 text-sm font-medium text-slate-900">{activeOrg.name}</p>
              <p className="px-3 text-xs capitalize text-slate-500">{activeOrg.pricing_tier}</p>
            </div>
          ) : null}
        </nav>
        <main className="flex-1 px-6 py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
